import { createRoot } from 'react-dom/client';

import App from './App';
import { ErrorBoundary } from '@/components/error-boundary';

import './index.css';

const storefrontFonts = document.getElementById('chamakpatti-fonts') as HTMLLinkElement | null;
if (storefrontFonts) {
  const enableFonts = () => { storefrontFonts.media = 'all'; };
  if (storefrontFonts.sheet) enableFonts();
  else storefrontFonts.addEventListener('load', enableFonts, { once: true });
}

createRoot(document.getElementById('root')!, {
  // Keeps caught errors off reportError(), which would raise the dev overlay.
  onCaughtError: (error, errorInfo) => {
    console.error(error, errorInfo.componentStack);
  },
}).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
